// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__-FDrW","modal":"Modal_modal__2xEuM","slide-down":"Modal_slide-down__A3A1m"};